import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-password-manager-nav',
  templateUrl: './password-manager-nav.component.html',
  styleUrls: ['./password-manager-nav.component.scss']
})
export class PasswordManagerNavComponent implements OnInit {

  @Input() appTitle;
  @Input() loginURL;
  @Input() registerURL;
  @Input() dashboardURL;
  constructor(private router: Router) { }

  ngOnInit() {
    
  }
  redirectLogin(){
    if(this.loginURL){
      this.router.navigateByUrl(`/${this.loginURL}`);
    }
  }
  redirectRegister(){
    if(this.registerURL){
      this.router.navigateByUrl(`/${this.registerURL}`);
    }
  }
  redirectDashboard(){
    if(this.dashboardURL){
      this.router.navigateByUrl(`/${this.dashboardURL}`);
    }
  }
}
